export default __webpack_public_path__ + "static/media/conatact-page-image.b951834a.jpg";